var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.882,
    height: 19.882,
    viewBox: "0 0 19.882 19.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2867",
    "data-name": "Group 2867",
    transform: "translate(4.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2866",
    "data-name": "Group 2866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4469",
    "data-name": "Path 4469",
    d: "M103.11,0a.71.71,0,0,0-.71.71V2.13h1.42V.71A.71.71,0,0,0,103.11,0Z",
    transform: "translate(-102.4)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2869",
    "data-name": "Group 2869",
    transform: "translate(14.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2868",
    "data-name": "Group 2868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4470",
    "data-name": "Path 4470",
    d: "M342.043,0a.71.71,0,0,0-.71.71V2.13h1.42V.71A.71.71,0,0,0,342.043,0Z",
    transform: "translate(-341.333)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2871",
    "data-name": "Group 2871",
    transform: "translate(0 2.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2870",
    "data-name": "Group 2870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4471",
    "data-name": "Path 4471",
    d: "M17.752,51.2h-2.13v2.84a.71.71,0,0,1-1.42,0V51.2H5.681v2.84a.71.71,0,0,1-1.42,0V51.2H2.13A2.13,2.13,0,0,0,0,53.33V66.822a2.13,2.13,0,0,0,2.13,2.13H17.752a2.13,2.13,0,0,0,2.13-2.13V53.33A2.13,2.13,0,0,0,17.752,51.2Zm.71,15.622a.71.71,0,0,1-.71.71H2.13a.71.71,0,0,1-.71-.71V57.591H18.462Z",
    transform: "translate(0 -51.2)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2873",
    "data-name": "Group 2873",
    transform: "translate(3.55 9.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2872",
    "data-name": "Group 2872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4472",
    "data-name": "Path 4472",
    d: "M87.463,238.933h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,1,0,0-1.42Z",
    transform: "translate(-85.333 -238.933)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2875",
    "data-name": "Group 2875",
    transform: "translate(8.521 9.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2874",
    "data-name": "Group 2874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4473",
    "data-name": "Path 4473",
    d: "M206.93,238.933h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,0,0,0-1.42Z",
    transform: "translate(-204.8 -238.933)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2877",
    "data-name": "Group 2877",
    transform: "translate(13.492 9.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2876",
    "data-name": "Group 2876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4474",
    "data-name": "Path 4474",
    d: "M326.4,238.933h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,1,0,0-1.42Z",
    transform: "translate(-324.267 -238.933)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2879",
    "data-name": "Group 2879",
    transform: "translate(3.55 12.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2878",
    "data-name": "Group 2878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4475",
    "data-name": "Path 4475",
    d: "M87.463,307.2h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,1,0,0-1.42Z",
    transform: "translate(-85.333 -307.2)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2881",
    "data-name": "Group 2881",
    transform: "translate(8.521 12.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2880",
    "data-name": "Group 2880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4476",
    "data-name": "Path 4476",
    d: "M206.93,307.2h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,0,0,0-1.42Z",
    transform: "translate(-204.8 -307.2)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2883",
    "data-name": "Group 2883",
    transform: "translate(13.492 12.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2882",
    "data-name": "Group 2882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4477",
    "data-name": "Path 4477",
    d: "M326.4,307.2h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,1,0,0-1.42Z",
    transform: "translate(-324.267 -307.2)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2885",
    "data-name": "Group 2885",
    transform: "translate(3.55 15.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2884",
    "data-name": "Group 2884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4478",
    "data-name": "Path 4478",
    d: "M87.463,375.467h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,1,0,0-1.42Z",
    transform: "translate(-85.333 -375.467)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2887",
    "data-name": "Group 2887",
    transform: "translate(8.521 15.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2886",
    "data-name": "Group 2886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4479",
    "data-name": "Path 4479",
    d: "M206.93,375.467h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,0,0,0-1.42Z",
    transform: "translate(-204.8 -375.467)",
    fill: "#525252"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2889",
    "data-name": "Group 2889",
    transform: "translate(13.492 15.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2888",
    "data-name": "Group 2888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    "data-name": "Path 4480",
    d: "M326.4,375.467h-1.42a.71.71,0,1,0,0,1.42h1.42a.71.71,0,1,0,0-1.42Z",
    transform: "translate(-324.267 -375.467)",
    fill: "#525252"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.1a4f38836ab6516716f5c96bab153968.svg";
export { ForwardRef as ReactComponent };